import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm5,16a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V8a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1ZM11,8v8a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8A1,1,0,0,1,8,7h2A1,1,0,0,1,11,8Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }